import dataType from '../dataType';

const isin = {
    name: 'ISIN',
    type: dataType.string
};

export default isin;
